function Commands() {
    return (
        <div>
            <h2 className="text-3xl font-bold mb-4 text-gray-800">Commands</h2>
            <p className="text-gray-700 mb-6">
                Here's a complete list of available commands to help you get the most out of OriginsBot.
            </p>

            {/* Admin Commands */}
            <div className="mb-8">
                <h3 className="text-2xl font-semibold mb-4 text-gray-800 flex items-center">
                    <span className="bg-red-500 text-white text-xs px-2 py-1 rounded mr-3">ADMIN</span>
                    Server Admins & Manage Messages Permission
                </h3>

                <div className="space-y-3">
                    <div className="border-l-4 border-red-500 bg-gray-50 pl-4 py-3 rounded-r">
                        <code className="text-sm font-mono bg-white px-3 py-1 rounded border border-gray-200">/habbonickname</code>
                        <p className="text-gray-700 mt-2">
                            Toggle the setting to force nicknames to be a users verified Habbo name. You can turn it on and run again to turn it off.
                        </p>
                    </div>

                    <div className="border-l-4 border-red-500 bg-gray-50 pl-4 py-3 rounded-r">
                        <code className="text-sm font-mono bg-white px-3 py-1 rounded border border-gray-200">/verifyrole</code>
                        <p className="text-gray-700 mt-2">
                            Already have a verified role on your server but switching to OriginsBot? Use this to swap out the default OriginsBot verified role to your own!
                        </p>
                    </div>

                    <div className="border-l-4 border-red-500 bg-gray-50 pl-4 py-3 rounded-r">
                        <code className="text-sm font-mono bg-white px-3 py-1 rounded border border-gray-200">/sendembed</code>
                        <p className="text-gray-700 mt-2">
                            A simple way to send an embed post to any channel in the Discord. You can choose which channel to send it to, include images, force tag a role and more.
                        </p>
                    </div>
                </div>
            </div>

            {/* Public Commands */}
            <div>
                <h3 className="text-2xl font-semibold mb-4 text-gray-800 flex items-center">
                    <span className="bg-[#5865F2] text-white text-xs px-2 py-1 rounded mr-3">PUBLIC</span>
                    Anyone
                </h3>

                <div className="space-y-3">
                    <div className="border-l-4 border-[#5865F2] bg-gray-50 pl-4 py-3 rounded-r">
                        <code className="text-sm font-mono bg-white px-3 py-1 rounded border border-gray-200">/lookup</code>
                        <p className="text-gray-700 mt-2">
                            Users can use this command on any Origins .com only player to see a quick Habbo profile of the user, including skill levels and XP.
                        </p>
                    </div>

                    <div className="border-l-4 border-[#5865F2] bg-gray-50 pl-4 py-3 rounded-r">
                        <code className="text-sm font-mono bg-white px-3 py-1 rounded border border-gray-200">/forgetme</code>
                        <p className="text-gray-700 mt-2">
                            If a user is verified in the OriginsBot ecosystem, they can run this to opt out and delete their verified status across all servers using OriginsBot.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Commands;